export default __webpack_public_path__ + "static/MerriweatherSans-Italic-552485a02548f9764dcd23dddd5712ab.ttf";